export default __webpack_public_path__ + "static/media/Mark-4-3D-Model-00.1142f437.jpg";